<template>
  <div class="search-results">
    <div
      class="result-text skip-latin-class"
      id="resultText"
    >
      <div class="search-heading">
        <h2>{{ pointStore.search.Heading }}</h2>
        <p>
          {{ pointStore.search.Showing }}
            <strong>{{ pointStore.searchResults }} {{ pointStore.search.Results }}&nbsp;</strong>
            <span v-if="pointStore.selectedCategories.length !== 0 || pointStore.selectedProducts.length !== 0 || pointStore.selectedDepths.length !== 0"> {{ pointStore.search.Match }}&nbsp;</span>
          <span
            class="selected"
            v-for="category in pointStore.selectedCategories"
            v-bind:key="category.Id"
          >{{ category.Name }}</span>
          <span
            class="selected"
            v-for="depth in pointStore.selectedDepths"
            v-bind:key="depth.Id"
          >{{ depth.Range }}</span>
          <span
            class="selected"
            v-for="product in pointStore.selectedProducts"
            v-bind:key="product.Id"
          >{{ product.FamilyName }}</span>
        </p>
      </div>
      <a
        id="clear-filter"
        class="clear-filter"
        @click="clearFilter"
        v-if="pointStore.selectedCategories.length !== 0 || pointStore.selectedProducts.length !== 0 || pointStore.selectedDepths.length !== 0"
      >{{ pointStore.filter.Clear }}
        <span class="icon-cross"></span></a>

      <div class="tool-list-container">
        <ToolPreview 
          v-for="(point, index) in pointStore.enabledPoints"
          v-bind:key="point.ArticleNr"
          :index="index"
          :point="point"
          @togglePoint="togglePoint"
        />
      </div>
    </div>
    <Transition name="fade">
      <SelectedPoint @togglePoint="togglePoint" v-if="!!pointStore.selectedPoint" />
    </Transition>
  </div>
</template>

<script setup>
import { usePointStore } from '../store/store';
import SelectedPoint from './selectedPoint.vue';
import ToolPreview from './toolPreview.vue';

const pointStore = usePointStore();

const props = defineProps({
  points: Array,
  enabledPoints: Array,
  selectedPoint: Object,
  selectedProducts: Array,
  selectedCategories: Array,
  selectedDepths: Array,
  searchResult: Number,
  search: Object,
  filter: Object
});

const emit = defineEmits([
  'clearFilter',
  'togglePoint',
  'marathon'
]);

function clearFilter() {
  emit('clearFilter', event);
}

function togglePoint(point) {
  emit('togglePoint', point, false);
}
</script>